<p-confirmdialog />
<p-toast position="bottom-center" />
<div class="roles-permissions-container">
  @if (loader) {
    <app-loading></app-loading>
  }

  <p-toolbar class="toolbar-class">
    <ng-template #start>
      <form [formGroup]="form">
        <div class="select-row">
          @if (!readOnly) {
            <div>
              {{ translate("Aplicaciones") }}:
              <p-select
                formControlName="appSelect"
                [options]="appData"
                [loading]="loader"
                [disabled]="selectorsReadOnly"
                optionLabel="Nombre"
                optionValue="Id"
                placeholder="{{ translate('seleccionar_aplicacion') }}"
                class="w-full md:w-56 select-min-width"
                size="small"
                [filter]="true"
                appendTo="body"
              ></p-select>
            </div>

            <div>
              {{ translate("Menu") }}:
              <p-select
                formControlName="menuSelect"
                [options]="menuData"
                [loading]="loader"
                [disabled]="selectorsReadOnly"
                optionLabel="Nombre"
                optionValue="Id"
                placeholder="{{ translate('seleccionar_menu') }}"
                class="w-full md:w-56 select-min-width"
                size="small"
                [filter]="true"
                appendTo="body"
              ></p-select>
            </div>
          } @else {
            <div class="readonly-menu-label">
              {{ translate("Menu") }}:
              <span class="m-label">{{ selectedMenuLabel }}</span>
            </div>
          }
        </div>
      </form>
    </ng-template>
    <ng-template #end>
      <p-button
        #exportBtn
        icon="pi pi-file-excel"
        styleClass="p-button-text p-button-sm export-button"
        (click)="openExportPanel($event, exportPanel)"
        [disabled]="!form.get('menuSelect')?.value || readOnly || loader"
        [attr.aria-label]="translate('Exportar_excel')"
        [pTooltip]="translate('Exportar_excel')"
        tooltipStyleClass="export-tooltip"
        appendTo="body"
        tooltipPosition="left"
      ></p-button>

      <p-overlayPanel
        #exportPanel
        [dismissable]="true"
        styleClass="export-overlay"
      >
        <div class="export-panel-content">
          <label class="panel-title">{{
            translate("Seleccionar_permiso")
          }}</label>
          <div class="perm-options">
            <div *ngFor="let p of permissionsData">
              <p-radioButton
                name="exportPerm"
                [value]="p.Id"
                [(ngModel)]="selectedExportPermId"
                [disabled]="readOnly"
              ></p-radioButton>
              <label class="perm-label">{{
                translate(p.Nombre) || p.Nombre
              }}</label>
            </div>
          </div>
          <div class="panel-actions">
            <p-button
              label="{{ translate('Cancelar') }}"
              class="p-button-text"
              (click)="exportPanel.hide()"
            ></p-button>
            <p-button
              label="{{ translate('Exportar') }}"
              (click)="confirmExport(exportPanel)"
              [disabled]="!selectedExportPermId || readOnly || loader"
            ></p-button>
          </div>
        </div>
      </p-overlayPanel>
    </ng-template>
  </p-toolbar>
  <div class="roles-permissions-row">
    <div class="menu-scroll-container">
      @if (menuTree && menuTree.length > 0) {
        @if (!readOnly) {
          <div class="all-check-container">
            <p-checkbox
              inputId="all"
              [(ngModel)]="allSelected"
              [binary]="true"
              (onChange)="onAllCheckboxChange($event)"
              [disabled]="readOnly"
            />
            <label for="all" class="m-label">{{ translate("Todos") }}</label>
          </div>
        }
        <p-tree
          [value]="menuTree"
          selectionMode="checkbox"
          [(selection)]="selectedNodes"
          [propagateSelectionUp]="true"
          [propagateSelectionDown]="true"
          (onNodeSelect)="onPermissionChange($event)"
          (onNodeUnselect)="onPermissionChange($event)"
          [style]="{ width: '400px', maxHeight: '600px', overflowY: 'auto' }"
        >
          <ng-template pTemplate="default" let-node>
            <span
              class="menu-label"
              [class.active-node]="isActiveOrAncestor(node) || allSelected"
              (click)="onLabelClick(node, $event)"
            >
              {{ translate(node.label) }}
              @if (
                node.data.Observaciones && node.data.Observaciones.length > 0
              ) {
                <br /><sup class="observaciones">{{
                  node.data.Observaciones
                }}</sup>
              }
            </span>
          </ng-template>
        </p-tree>
      }
    </div>
    <div class="permissions-table-container">
      @if (activeMenuNode) {
        <h3 class="title-selected">
          {{ translate("permisos_para") }}:
          {{ translate(activeMenuNode.label) }}
        </h3>

        <div class="table-scroll-x">
          <p-table
            [value]="permissionsData"
            [scrollable]="true"
            scrollHeight="600px"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pFrozenColumn class="sticky-col">Permiso</th>
                <th scope="col">{{ translate("Todos") }}</th>

                <th *ngFor="let role of rolesData">
                  {{ role.Nombre }}
                </th>
              </tr>

              <tr>
                <th pFrozenColumn class="sticky-col"></th>
                <th scope="col"></th>

                <th *ngFor="let role of rolesData">
                  <p-toggleSwitch
                    [disabled]="readOnly"
                    [ngModel]="areAllPermissionsChecked(role.Id)"
                    (onChange)="toggleAllPermissions(role.Id, $event.checked)"
                  ></p-toggleSwitch>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-permit>
              <tr>
                <td pFrozenColumn class="sticky-col">
                  {{ translate(permit.Nombre) }}
                </td>

                <td>
                  <p-toggleSwitch
                    [disabled]="readOnly"
                    [ngModel]="areAllRolesCheckedForPermission(permit.Id)"
                    (onChange)="
                      toggleAllRolesForPermission(permit.Id, $event.checked)
                    "
                  ></p-toggleSwitch>
                </td>

                <td *ngFor="let role of rolesData">
                  <p-toggleSwitch
                    [disabled]="readOnly"
                    [(ngModel)]="permissionMatrix[role.Id][permit.Id]"
                  ></p-toggleSwitch>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div class="actions">
          @if (!readOnly) {
            <p-button
              label="{{ translate('Cancelar') }}"
              severity="secondary"
              variant="outlined"
              (click)="cancelActiveNode()"
            ></p-button
            ><p-button
              label="{{ translate('Guardar') }}"
              (click)="savePermissions()"
            ></p-button>
          }
        </div>
      } @else {
        @if (menuTree && menuTree.length > 0) {
          <h4 class="text-empty">
            {{ translate("seleccione_elemento_menu") }}
          </h4>
        }
      }
    </div>
  </div>
</div>
